import { same } from "@/utils/same"
import type { SessionTabs } from "../layout-model"

export function isLayoutRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

export function createLayoutPreferenceMigration(
  normalizeTabs: (key: string, tabs: SessionTabs) => SessionTabs,
) {
  return (value: unknown) => {
    if (!isLayoutRecord(value)) return value
    const sessionTabs = value.sessionTabs
    const migratedSessionTabs = (() => {
      if (!isLayoutRecord(sessionTabs)) return sessionTabs
      let changed = false
      const next = Object.fromEntries(Object.entries(sessionTabs).map(([key, tabs]) => {
        if (!isLayoutRecord(tabs) || !Array.isArray(tabs.all)) return [key, tabs]
        const current = {
          all: tabs.all.filter((tab): tab is string => typeof tab === "string"),
          active: typeof tabs.active === "string" ? tabs.active : undefined,
        }
        const normalized = normalizeTabs(key, current)
        if (current.all.length !== tabs.all.length || !same(current.all, normalized.all) ||
          current.active !== normalized.active || (tabs.active !== undefined && typeof tabs.active !== "string")) {
          changed = true
        }
        return [key, normalized]
      }))
      return changed ? next : sessionTabs
    })()

    // The sidebar's open state is lifecycle state, not a durable preference.
    const cleaned: Record<string, unknown> = { ...value, sessionTabs: migratedSessionTabs }
    if (isLayoutRecord(cleaned.sidebar)) {
      const { opened: _opened, ...sidebarValue } = cleaned.sidebar
      cleaned.sidebar = sidebarValue
    }
    return cleaned
  }
}
